<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/16JMv5y/tc-custom/9780802189783.jpg?1706964433919" alt="This image is the cover for the book Zanzibar Chest"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Zanzibar Chest
      </h1>
      <p class="bookDescription body article font2">
        <b>An examination of colonialism and its consequences. “A sweeping, poetic homage to Africa, a continent made vivid by Hartley’s capable, stunning prose” (<i>Publishers Weekly</i>).</b><br/>  <br/> In his final days, Aidan Hartley’s father said to him, “We should have never come here.” Those words spoke of a colonial legacy that stretched back through four generations of one British family. From a great-great-grandfather who defended British settlements in nineteenth-century New Zealand, to his father, a colonial officer sent to Africa in the 1920s and who later returned to raise a family there—these were intrepid men who traveled to exotic lands to conquer, build, and bear witness. And there was Aidan, who became a journalist covering Africa in the 1990s, a decade marked by terror and genocide.<br/>  <br/> After encountering the violence in Somalia, Uganda, and Rwanda, Aidan retreated to his family’s house in Kenya where he discovered the Zanzibar chest his father left him. Intricately hand-carved, the chest contained the diaries of his father’s best friend, Peter Davey, an Englishman who had died under obscure circumstances five decades before. With the papers as his guide, Hartley embarked on a journey not only to unlock the secrets of Davey’s life, but his own.<br/>  <br/> “The finest account of a war correspondent’s psychic wracking since Michael Herr’s <i>Dispatches</i>.” —Rian Malan, author of <i>My Traitor’s Heart</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Aidan Hartley
      </h2>
      
      <p class="authorDescription body article"><B>Aidan Hartley</B> was born in 1965 and brought up in East Africa. He read English at Oxford and studied politics at London University. He joined Reuters as a foreign correspondent and worked in the Balkans, the Middle East, and Russia. He now writes a column for the <I>Spectator</I> (UK). He lives with his family in Kenya.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grove Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?082c1634